import type { QueryClient } from '@tanstack/query-core';

export function replaceObjectInReactQueryCache<T extends { id: number }>(
    queryClient: QueryClient,
    obj: T,
    name: string
) {
    queryClient.setQueriesData<T>({ queryKey: [name, 'detail', obj.id], exact: true }, obj);
    queryClient.setQueriesData<T[]>({ queryKey: [name, 'list'], exact: true }, list => {
        if (Array.isArray(list)) {
            return list.map(old => (old.id === obj.id ? obj : old));
        }
        return list;
    });
}

export function removeObjectFromReactQueryCache<T extends { id: number }>(
    queryClient: QueryClient,
    id: number,
    name: string
) {
    queryClient.removeQueries({ queryKey: [name, 'detail', id], exact: true });
    queryClient.setQueriesData<T[]>({ queryKey: [name, 'list'], exact: true }, list => {
        if (Array.isArray(list)) {
            return list.filter(e => e.id !== id);
        }
        return list;
    });
}
export function clearCache(queryClient?: QueryClient) {
    window.localStorage.removeItem('currentProductId');
    queryClient?.clear();
}
